import styled, { keyframes } from 'styled-components';
import backgroundImgSignIn from '../../../assets/PNG/signin.png';
import backgroundImgSignUp from '../../../assets/PNG/signup.png';
import { Label } from '../../../components/uielements';
import { palette } from 'styled-theme';

export const Main = styled.main`
  display: grid;
  grid-template-columns: 1fr 1fr;
  height: 100vh;
  width: 100vw;
`;

export const SectionLeft = styled.form`
  background-color: ${palette('background', 0)};
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
  padding: 80px 120px 0px 120px;
`;

export const SectionLeftSignUp = styled.form`
  background-color: ${palette('background', 0)};
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
  padding: 0px 120px 0px 120px;
`;

export const SignInSectionRight = styled.section`
  background-image: url(${backgroundImgSignIn});
  background-size: cover;
  background-position: center;
`;

export const SignUpSectionRight = styled.section`
  background-image: url(${backgroundImgSignUp});
  background-size: cover;
  background-position: center;
`;

export const Heading = styled(Label).attrs({ size: 'header2', color: 'black', weight: 'bold' })`
  text-transform: uppercase;
`;

export const AltText = styled.p`
  font-family: 'Inter';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
`;

export const LinkText = styled.span`
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const InputLabel = styled.label`
  font-size: 0.85rem;
  margin-bottom: 0.3rem;
  color: #9e9eb9;
  font-family: 'Inter';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0.12px;
`;

export const HelperText = styled.div`
  color: red;
  font-size: 0.875rem;
  margin-top: 4px;
`;

export const Modal = styled.div`
  display: ${({ open }) => (open ? 'flex' : 'none')};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  animation: fadeIn 0.3s ease-in-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const ModalContent = styled.div`
  background-color: #fff;
  padding: 2rem;
  border-radius: 5px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  text-align: center;
  max-width: 400px;
  width: 90%;

  p {
    font-size: 1.2rem;
    margin-top: 1rem;
    color: #333;
  }
`;

const slideIn = keyframes`
  from {
    transform: translateY(-100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

export const ToastWrapper = styled.div`
  position: fixed; // Changed from absolute to fixed
  top: 20px;
  right: 20px;
  z-index: 99999; // Increased z-index
  pointer-events: none; // Prevents blocking clicks
`;

export const ToastContainer = styled.div`
  animation: ${slideIn} 0.3s ease-out;
  background-color: #ff4d4f;
  color: white;
  padding: 16px 24px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  margin-bottom: 10px;
  min-width: 300px;
  max-width: 400px;
`;

export const ToastMessage = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.5;
`;
